import { Box } from "@mui/material";
import { MaterialUiProviders } from "@src/mui/providers/MaterialUiProviders";
import React from "react";

export interface LegacyRouteWrapperProps {
  children: React.ReactNode;
}

export function LegacyRouteWrapper(props: LegacyRouteWrapperProps) {
  const { children } = props;

  return (
    <MaterialUiProviders>
      <Box
        sx={(theme) => ({
          padding: 3,
          flex: 1,
          minHeight: 0,
          // On mobile/tablet, add padding to account for fixed floating navigation
          [theme.breakpoints.down("lg")]: {
            ...(theme.size?.floatingNavigation && {
              paddingBottom: `calc(${theme.size.floatingNavigation.height} + ${
                theme.size.floatingNavigation.margin
              } + ${theme.spacing(3)})`,
            }),
          },
        })}
      >
        {children}
      </Box>
    </MaterialUiProviders>
  );
}
